import React, { useState } from 'react';
import { Box, Grid, Modal, Tooltip, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CommonNoDataFound from 'components/CommonNoDataFound/CommonNoDataFound';
import { getDateFormat } from 'utils/utils';
import CommonImageModal from 'components/commonImageModal/CommonImageModal';
import CommonCardDetails from 'components/commonCardDetails/CommonCardDetails';
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined';
import CommonMultiImageForm from 'components/commonMultiImageForm/CommonMultiImageForm';

function MoreDetails(props) {
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const [reuploadModal, setReuploadModal] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);

const handleReuploadClick = (doc) => {

  const expired =
    doc.status === "Approved" && new Date(doc.expiryDate) < new Date();

  const formattedDoc = {
    id: doc.attributeId || doc.id,
    attributeName: doc.complianceName,
    attributeType: doc.attributeType,
    isMandatory: doc.isMandatory,
    isExpiring: doc.isExpiring,

    complianceValue: [
      {
        id: doc.id,
        atributeValue: doc.atributeValue || doc.number || "",
        expiryDate: doc.expiryDate || "",
        status: doc.status,
        isExpired: expired,
        complianceFile: doc.complianceFile || {}
      }
    ]
  };

  setSelectedDoc(formattedDoc);
  setReuploadModal(true);
};

  const isExpired = (date) => {
    if (!date) return false;
    return new Date(date) < new Date();
  };


  const handleOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedImage(null);
    setOpen(false);
  };

  const filteredFiles = props?.details?.filter(
    (val) => val.attributeType === 'File'
  );
  const filteredImages = props?.details?.filter(
    (val) => val.attributeType === 'Image'
  );
  const filteredTextDocuments = props?.details?.filter(
    (val) => val.attributeType === 'text'
  );
  const filteredMultiImages = props?.details?.filter(
    (val) => val.attributeType === 'Multi-Image'
  );

  return (
    <div>
      {props?.details?.length === 0 || props?.details === undefined ? (
        <CommonNoDataFound />
      ) : (
        <>
          {filteredFiles?.length > 0 && (
            <Typography variant={'body2'} className="mb20 p10 font18">
              Text With File Documents
            </Typography>
          )}
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="start"
            gap={2}
          >
            {props?.details?.map((val, idx) => {
              if (val?.attributeType === 'File') {
                return (
                  <CommonCardDetails md={3.6} sm={12} val={val} handleOpen={handleOpen} onReuploadClick={handleReuploadClick} />
                );
              }
              return null;
            })}
          </Grid>

          {filteredFiles?.length > 0 && <div className="dashedborder"></div>}
          {filteredImages?.length > 0 && (
            <Typography className="mb20 p10 font18">Text With Image</Typography>
          )}
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="start"
          >
            {props?.details?.map((val, idx) => {
              if (val?.attributeType === 'Image') {
                return (
                  <CommonCardDetails md={3.7} sm={12} val={val} handleOpen={handleOpen} onReuploadClick={handleReuploadClick} />
                );
              }
              return null;
            })}
          </Grid>

          {filteredImages?.length > 0 && <div className="dashedborder"></div>}
          {filteredMultiImages?.length > 0 && (
            <Typography className="mb20 p10 font18">
              Text With Multi-Image
            </Typography>
          )}
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="start"
          >
            {props?.details?.map((val, idx) => {
              if (val?.attributeType === 'Multi-Image') {
                return (
                  <CommonCardDetails md={3.7} sm={12} val={val} handleOpen={handleOpen} onReuploadClick={handleReuploadClick} />
                );
              }
              return null;
            })}
          </Grid>

          {filteredMultiImages?.length > 0 && (
            <div className="dashedborder"></div>
          )}
          {filteredTextDocuments?.length > 0 && (
            <Typography className="mb20 p10 font18">Text Documents</Typography>
          )}
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="start"
            className="mb30"
            gap={2}
          >
            {props?.details?.map((val, idx) => {
              if (val?.attributeType === 'text') {
                return (
                  <Grid
                    item
                    md={3.7}
                    sm={12}
                    className="borderStyle p10 m10"
                    key={val.id}
                  >
                    <Grid
                      item
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      className="p10 backgroundGrey"
                    >
                      <Grid item>
                        <h1 className="colorBlack font14 fw600 textOverflow">
                          {val?.complianceName}
                          {val?.isMandatory && (
                            <span className="colorRed">*</span>
                          )}
                        </h1>
                        <p className="font12 fontNormal colorGrey">
                          Number: {val?.atributeValue}
                        </p>
                        {val?.isExpiring &&
                          <p className="font12 fontNormal colorPrimary">
                            <span className="colorPrimary">Exp:&nbsp;</span>
                            {getDateFormat(val?.expiryDate, 'moreDetails')}
                          </p>}
                        {val?.status && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <Tooltip title={val?.rejectionReason}>
                              <Typography
                                className={`${val?.status === "Approved" && isExpired(val?.expiryDate) ? "RejectedBtn" : val?.status + "Btn"} flexDirection`}
                                style={{ border: 'none', background: 'transparent', padding: 0, display: 'flex', alignItems: 'center' }}
                              >
                                {val.status === 'Rejected' && <ErrorOutlineIcon className="marginRight3 font16" />}
                                {val?.status === "Approved" && isExpired(val?.expiryDate) ? (
                                  <span className="font14">
                                    <span className="colorRed">Expired (</span>
                                    <span className="colorGrey">Approved</span>
                                    <span className="colorRed">)</span>
                                  </span>
                                ) : (val?.status)}
                              </Typography>
                            </Tooltip>

                            {(val.status === 'Rejected' || (val?.status === "Approved" && isExpired(val?.expiryDate))) && (
                              <Tooltip title="Click to Reupload">
                                <CloudSyncOutlinedIcon
                                  className="cursor"
                                  style={{ color: '#2e7d32', fontSize: '18px' }}
                                  onClick={() => handleReuploadClick(val)}
                                />
                              </Tooltip>
                            )}
                          </div>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                );
              }
              return null;
            })}
          </Grid>

          {open && <CommonImageModal
            open={open}
            handleClose={handleClose}
            selectedImage={selectedImage}
          />}
            {reuploadModal && (
              <CommonMultiImageForm
                open={reuploadModal}
                handleClose={() => setReuploadModal(false)}
                reupload={true}
                tabName="driver"
                driverId={props?.driverId}
                details={[selectedDoc]}
                onSuccess={() => {
                  setReuploadModal(false);
                  props?.refreshCompliance();
                }}
              />
            )}
        </>
      )}
    </div>
  );
}

export default MoreDetails;
